import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import KlaviyoCredentialsStore from "../../../stores/credentials/klaviyo-credentials-store";

interface IIntegrationProps {
    credentialsStore: KlaviyoCredentialsStore,
    vGroup: IValidationGroup,
}

const KlaviyoCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='Klaviyo api key' required key='api_key'>
                <Input
                    value={credentialsStore.api_key}
                    onChange={v => credentialsStore.api_key = v}
                    validationGroup={vGroup}
                    adornment={''}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default KlaviyoCredentials;
